// removed by extract-text-webpack-plugin
module.exports = {"root":"_ch1pY","label":"_1Hqh-","content":"_32igh","highlight":"_1AHd1","ctaButton":"_yqPPJ","benefits":"_2e_hg","benefitsItem":"_3OtDl","name":"_vNPz3","description":"_2pTdR","price":"_1AIXM","symbol":"_39_-Y","unit":"_2dj77","subscriptionDescription":"_2t8XR","quota":"_1G9uf","number":"_2345S"};


//////////////////
// WEBPACK FOOTER
// ./app/containers/Premium/components/Subscription/Subscription.scss
// module id = 1330
// module chunks = 3